import React from 'react';
import PropTypes from 'prop-types';
import TimelineMax from 'TimelineMax';
import TweenMax from 'TweenMax';
import 'ScrollToPlugin';
import { inject, observer } from 'mobx-react';

import { getAncestorByAttr } from '../utils';

const nextBlockTransitionBehavior = (WrappedComponent, type) => {
  class NextBlockTransitionBehavior extends React.Component {
    static propTypes = {
      sceneChangerStore: PropTypes.object.isRequired,
      envStore: PropTypes.object.isRequired,
      progressStore: PropTypes.object.isRequired,
    };

    state = {
      animationRunning: false,
      hover: false,
    };

    runAnimation() {
      this.setState({ animationRunning: true });
      return new Promise(resolve => {
        // TODO: искать элемент по-другому
        const parentScene = getAncestorByAttr(this.containerNode, 'data-scene');
        const tl = new TimelineMax();
        tl.add(
          TweenMax.to(window, 0.5, {
            scrollTo: { y: this.containerNode },
          })
        );
        tl.to(this.contentNode, 0.35, { alpha: 0 });
        tl.to(
          this.imageNode,
          1.2,
          {
            scale: 1,
            onComplete: () => {
              this.props.sceneChangerStore.setShouldHandleColors();
            },
          },
          '-=0.5'
        );

        this.props.progressStore.addMediaLoadedListener(() => {
          tl.to(this.imageNode, 0.65, {
            scale: 1.1,
            delay: 0.1,
          });
          tl.to(
            parentScene,
            0.65,
            {
              alpha: 0,
              onComplete: () => {
                resolve({ type: 'nextBlock' });
              },
            },
            '-=0.65'
          );
        });
      });
    }

    handleMouseOver = () => {
      this.setState({ hover: true });
    };

    handleMouseLeave = () => {
      this.setState(state => ({ hover: state.animationRunning ? state.hover : false }));
    };

    handleLinkClick = to => {
      if (this.state.animationRunning) {
        return;
      }

      this.props.sceneChangerStore.onLinkClick(to, () => this.runAnimation());
    };

    render() {
      return (
        <WrappedComponent
          onLinkClick={this.handleLinkClick}
          containerNode={node => (this.containerNode = node)}
          contentNode={node => (this.contentNode = node)}
          imageNode={node => (this.imageNode = node)}
          animationRuning={this.state.animationRunning}
          hover={this.state.hover}
          onMouseOver={this.handleMouseOver}
          onMouseLeave={this.handleMouseLeave}
          isUserAgentMobile={this.props.envStore.isUserAgentMobile}
          onComponentInViewport={isVisible => this.setState({ hover: !!isVisible })}
          type={type}
          {...this.props}
        />
      );
    }
  }

  return inject(stores => ({
    sceneChangerStore: stores.store.sceneChanger,
    envStore: stores.store.envStore,
    progressStore: stores.store.progress,
  }))(observer(NextBlockTransitionBehavior));
};

export default nextBlockTransitionBehavior;



// WEBPACK FOOTER //
// ./src/components/nextBlockTransitionBehavior.js